import { Component, Watch } from 'vue-property-decorator'
import Template from '@/components/BaseCurd/template'
import {
  exportMalfunctionTypeTemplate,
  importMalfunctionType,
  exportMalfunctionType
} from '@/api/api'
import { MalfunctionTypeServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'
import ImportButton from '@/components/ImportButton/index.vue'
import ExportButton from '@/components/ExportButton/index.vue'
import CurdForm from '@/components/BaseCurd/form'

const mftsp = new MalfunctionTypeServiceProxy()
const crsp = new CodeRuleServiceProxy()

@Component
export default class FaultType extends Template {
  // 故障类型
  name = 'FaultType'
  options = {
    retrieve: mftsp.getPageRepairApply.bind(mftsp),
    search: mftsp.getMalfunctionDetail.bind(mftsp),
    create: mftsp.createRepairApply.bind(mftsp),
    update: mftsp.updateMalfunction.bind(mftsp),
    delete: mftsp.deleteMalfunction.bind(mftsp)
  }
  acl = {
    create: 'page_business_create_fault_type',
    update: 'page_business_edit_fault_type',
    delete: 'page_business_delete_fault_type'
  }
  ie = true
  malfunctionTypeLists = []
  importFilename = '故障类型.xlsx'
  exportFilename = '故障类型.xlsx'
  createInitData = {}
  createdTimes = 0
  malfunctionTypeList = []
  disabled = false
  downloadFn = exportMalfunctionTypeTemplate
  importFn = importMalfunctionType
  exportFn = this.handleExport

  get lang() {
    return {
      create: this.$t('page_business_create_fault_type'),
      placeholder: this.$t('keyword'),
      search: this.$t('search'),
      delete: this.$t('delete')
    }
  }

  async handleExport() {
    let params = {
      exportSelected: !!(this.selectedIds.length),
      selectedRecords: this.selectedIds
    }
    return await exportMalfunctionType(params)
  }
  created(){
    this.getCodeRules()
  }
  async getCodeRules(){
    const res = await crsp.list('MalfunctionTypeObject')
    let arr = []
    arr = res
    arr.map(item => {
      this.malfunctionTypeLists.push({
        label: item.name,
        value:item.id
      })
    })
  }

  async handleChang(val){
    if(val){
      this.disabled = true
      await this._form_2.form.setFieldsValue({['code']:''})
    }else {
      this.disabled = false
    }
  }

  render() {
    return this.customRender()
  }

  extraHeaderAction() {
    return [
      <ImportButton
        filename={this.importFilename}
        downloadFn={this.downloadFn}
        importFn={this.importFn}
        refresh={this.refresh}
        newResFlag={true}
        style="margin-left: 8px"
      />,
      <ExportButton
        simple
        filename={this.exportFilename}
        exportFn={this.exportFn}
        disabled={!(this.selectedIds.length)}
        style="margin-left: 8px"
      />
    ]
  }

  get columns() {
    return [
      // 序号
      /*{ title: this.$t('page_resource_pool_no'), dataIndex: 'order', width: 100, ellipsis: true,
        customRender: (val, record, arr) => (arr + 1)},*/
      // 类型编码
      { title: this.$t('page_business_fault_type_code'), dataIndex: 'code', width: 250, ellipsis: true },
      // 故障类型
      { title: this.$t('page_business_fault_type'), dataIndex: 'name', width: 250, ellipsis: true },
      { title: this.$t('remark'), dataIndex: 'remark', ellipsis: true }
    ]
  }

  get schema() {
    return {
      codeRuleId: {
        label: this.$t('page_system_coding_rules'),
        type: 'select',
        display:this.showDrawer?"none":"block",
        props: {
          allowClear: true,
          placeholder: this.$t('page_system_select_coding_rule'),
          maxLength: 128,
        },
        rules: [
          {
            message: this.$t('page_system_coding_rules')
          }
        ],
        options:this.malfunctionTypeLists,
        on: {
          change: this.handleChang
        },
      },
      code: {
        label: this.$t('page_business_fault_type_code'),
        type: 'input',
        props: {
          placeholder: this.$t('page_business_fault_type_enter_code'),
          // maxLength: 48,
          disabled: this.disabled || this.showDrawer
        },
        rules: [
          {
            required: !this.disabled,
            message: this.$t('page_business_fault_type_enter_code')
          },
          { max: 32, message: (this.$t('chart_limit') as string).replace('{0}', '32') }
        ]
      },
      name: {
        label: this.$t('page_business_fault_type'),
        type: 'input',
        props: {
          placeholder: this.$t('page_business_fault_type_enter_type')
        },
        rules: [
          {
            required: true,
            message: this.$t('page_business_fault_type_enter_type')
          },
          { max: 64, message: (this.$t('chart_limit') as string).replace('{0}', '64') }
        ]
      },
      remark: {
        label: this.$t('remark'),
        type: 'input',
        props: {
          placeholder: this.$t('remark_tips')
        },
        rules: [
          { max: 100, message: this.$t('page_material_warehousing_custom_more100') }
        ]
      }
    }
  }

  resetFormFields(type) {
    if (type === 'add') {
      this.createInitData = { createdTimes: ++this.createdTimes }
    } else {
      let temp = { ...this.editdata }
      this.editdata = {}
      this.editdata = { ...temp }
    }
  }
  cancelHandle(){
    this.showDialog = false
    this.disabled = false
  }
  handleClose() {
    this.showDialog = false 
    this.disabled = false
  }

  renderHeader(slot = null) {
    const { hidden } = this;
    const add = hidden.includes("create") ? null : (
      <a-button
        v-acl={this.acl.create}
        type="primary"
        style={{ marginRight: "8px" }}
        onClick={this.openCreateWindow}
      >
        {this.lang.create}
      </a-button>
    );
    const del = hidden.includes("delete") ? null : (
      <a-popconfirm
        title={this.$t("page_resource_pool_confirm_delete")}
        onConfirm={this.deleteData}
        okText={this.$t("yes")}
        cancelText={this.$t("no")}
        disabled={this.selectedIds.length < 1}
      >
        <a-button
          v-acl={this.acl.delete}
          type="danger"
          disabled={this.selectedIds.length < 1}
        >
          {this.lang.delete}
        </a-button>
      </a-popconfirm>
    );
    const print = hidden.includes("create") ? null : (
      <a-button
        style={{ marginLeft: "8px" }}
        disabled={this.selectedIds.length < 1}
        onClick={this.printing}
      >
        {this.$t('page_print_code')}
      </a-button>
    );
    return (
      <div
        slot="action"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          {add}
          {del}
          {this.ie ? this.extraHeaderAction() : null}
          {print}
        </div>
        {this.showSearch ? ( <div style="display:flex;align-items:center">
          {slot}
          <a-input-search
            placeholder={this.lang.placeholder}
            onSearch={this.onSearch}
            enterButton={this.lang.search}
            allowClear={true}
          ></a-input-search>
        </div>) : null}
      </div>
    );
  }

  renderDialog() {
    return (
      <a-modal
        class={this.templateModalClass}
        onCancel={this.cancelHandle}
        title={this.createModalTitle}
        visible={this.showDialog}
        destroyOnClose={true}
        maskClosable={false}
      >
        <div slot="footer">
          <a-button
            style="margin-right:8px"
            onClick={() => this.resetFormFields('add')}
          >
            {this.$t('page_calendar_reset')}
          </a-button>
          <a-button
            style="margin-right:8px"
            onClick={this.handleClose}
          >
            {this.$t('cancel')}
          </a-button>
          <a-button type="primary" onClick={this.createData} loading={this.saveLoading}>
            {this.createModalSaveBtn}
          </a-button>
        </div>
        <CurdForm
          acl={{
            save: this.acl.create
          }}
          ref="_form_2"
          type="create"
          schema={this.schema}
          name={this.name}
          footer={false}
          defaultValue={this.createInitData}
        />
      </a-modal>
    )
  }

  renderDrawer() {
    return (
      <a-modal
        title={this.$t('edit')}
        visible={this.showDrawer}
        onCancel={() => (this.showDrawer = false)}
        extraStyle={{ paddingBottom: '50px' }}
      >
        <CurdForm
          acl={{
            save: this.acl.update
          }}
          ref="_form_1"
          type="edit"
          schema={this.schema}
          defaultValue={this.editdata}
          name={this.name}
          footer={false}
        />
        <div
          slot="footer">
          <a-button
            style="margin-right:8px"
            onClick={() => this.resetFormFields('edit')}
          >
            {this.$t('page_calendar_reset')}
          </a-button>
          <a-button
            style="margin-right:8px"
            onClick={() => (this.showDrawer = false)}
          >
            {this.$t('cancel')}
          </a-button>
          <a-button type="primary" onClick={this.updateData} loading={this.saveLoading}>
            {this.$t('save')}
          </a-button>
        </div>
      </a-modal>
    )
  }

}
